<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="breadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="订单信息" name="order">
            <OrderInfo ref="orderInfo" :form="form" :areaSelectKey="areaSelectKey" @updateArea="updateAreaSelection"
              @goBack="goBack" />
          </el-tab-pane>
          <el-tab-pane label="会员服务信息" name="flow">
            <FlowServiceInfo :flowSummary="flowSummary" :flowBills="flowBills" />
          </el-tab-pane>
          <el-tab-pane label="解约/买断申请记录" name="terminate">
            <TerminateRecord :activityOrderNo="form.activityOrderNo" :terminateSummary="terminateSummary" />
          </el-tab-pane>
        </el-tabs>
        <div class="bottom-actions">
          <el-button type="primary" @click="onSave" v-if="activeTab === 'order'">保存</el-button>
          <el-button @click="goBack">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderInfo from './OrderInfo.vue';
import FlowServiceInfo from './FlowServiceInfo.vue';
import TerminateRecord from './TerminateRecord.vue';

export default {
  name: "PileDonationActivityDetail",
  components: { OrderInfo, FlowServiceInfo, TerminateRecord },
  data() {
    return {
      pageTitle: "送桩活动详情",
      areaSelectKey: 0,
      activeTab: "order",
      breadCrumb: [
        { name: "营销活动" },
        { name: "送桩活动" },
        { name: "订单详情" },
      ],
      form: {
        buyName: "", createTime: "", activityOrderNo: "", relationGoodsOrderNo: "", userName: "", userMobile: "",
        orderStatus: "", orderStatusText: "", flowServiceStatusText: "", deviceBindTime: "", switchDeviceNo: "", switchDeviceAssetNo: "",
        pileDeviceNo: "", pileDeviceAssetNo: "", pileCode: "", pileAssetCode: "", pileInstallCompleteTime: "", mainServiceOrderNo: "",
        memberServiceStatusText: "", memberServiceTotalPaid: "", memberServiceUsedMonths: "",
        terminateTypeText: "", terminateApplyTime: "", terminateCompleteTime: "", terminateReason: "",
        buyoutTypeText: "", buyoutCompleteTime: "", isViolationBuyoutText: "", isViolationBuyout: "", violationBuyoutReason: "",
        buyoutFreeDepositAmount: "", zhimaCreditStatusText: "", subsidyEligibleText: "",
        actualAmountStatusName: "", actualAmountCumulativeMonths: "", actualAmountTotal: "", isEndDisbursement: "",
        province: "", city: "", area: "", detailAddress: "", remark: "",
        refundReasonTypeName: "", cancelRequestTime: "", refundCancelReason: "", buyOutCancelFinishTime: "",
        pileInstallCompletedTime: "", pileInstallOrderNo: "N", installFailReason: "",
        activityOrderInstallStatus: "", activityOrderInstallStatusName: "",
        activityOrderContractStatus: "", activityOrderContractStatusName: "",
        agentName: "", agentPhone: "", agentLevel: "", parentAgentName: "",
      },
      flowSummary: { totalUsed: "", totalPaid: "", chargingStandards: "", currentStatus: "", periodStart: "", periodEnd: "", remainDays: "" },
      flowBills: [],
      terminateSummary: { terminateType: "", terminateReason: "", applyTime: "", completeTime: "", refundAmount: "", payableAmount: "" },
      activityOrderId: "",
    };
  },
  watch: {
    "$route.query"(val) {
      if (val.activityOrderNo) {
        this.form.activityOrderNo = val.activityOrderNo;
        this.loadDetailData();
      }
    },
  },
  mounted() {
    this.form.activityOrderNo = this.$route.query.activityOrderNo || "";
    if (this.form.activityOrderNo) {
      this.loadDetailData();
    } else {
      this.$message.warning("缺少订单编号参数");
    }
  },
  methods: {
    loadDetailData() {
      if (!this.form.activityOrderNo) {
        this.$message.error("缺少订单编号参数");
        return;
      }
      this.$U.showLoading(this);
      const params = {
        activityOrderNo: this.form.activityOrderNo,
        activityExtendTypeEnum: "FREE_PILE_ACTIVITY_PAY",
      };
      this.$H.post(this, this.$A.activityOrder.circuitBreakerActivityGet, params)
        .then((res) => {
          const data = res?.data?.data || res?.data || {};
          if (res?.data?.status === 200 || res?.data?.data) {
            const formMap = {
              purchaseName: "buyName", createdWhen: "createTime", activityOrderNo: "activityOrderNo",
              mapNo: "relationGoodsOrderNo", name: "userName", mobile: "userMobile",
              orderStatus: "orderStatus", activityOrderStatusName: "orderStatusText", bindTime: "deviceBindTime",
              pileCode: "pileDeviceNo", pileAssetCode: "pileDeviceAssetNo",
              pileInstallCompletedTime: "pileInstallCompletedTime", pileInstallOrderNo: "pileInstallOrderNo",
              installFailReason: "installFailReason",
              activityOrderInstallStatus: "activityOrderInstallStatus", activityOrderInstallStatusName: "activityOrderInstallStatusName",
              activityOrderContractStatus: "activityOrderContractStatus", activityOrderContractStatusName: "activityOrderContractStatusName",
              cancelRequestTime: "terminateApplyTime", cancelFinishTime: "terminateCompleteTime",
              cancelReason: "terminateReason", refundCancelReason: "terminateReason",
              refundReasonTypeName: "terminateTypeText", buyoutReasonTypeName: "buyoutTypeText",
              buyOutCancelFinishTime: "buyoutCompleteTime", province: "province", city: "city",
              area: "area", address: "detailAddress", remark: "remark",
              actualAmountCumulativeMonths: "actualAmountCumulativeMonths", actualAmountTotal: "actualAmountTotal",
              agentName: "agentName", agentPhone: "agentPhone", agentLevel: "agentLevel", parentAgentName: "parentAgentName",
            };
            Object.keys(formMap).forEach((apiKey) => {
              const formKey = formMap[apiKey];
              if (data[apiKey] !== null && data[apiKey] !== undefined) {
                this.form[formKey] = data[apiKey];
              }
            });
            if (!this.form.pileInstallOrderNo) this.form.pileInstallOrderNo = "N";
            if (data.activityOrderId != null && data.activityOrderId !== "") {
              this.activityOrderId = data.activityOrderId;
            }
            // API 返回 *Name（展示文案），需映射为 code 供下拉回显
            const installStatusNameToCode = { "未勘察未安装": "INVESTIGATION_INSTALL_INIT", "已勘察已安装": "INVESTIGATION_INSTALL_COMPLETED", "已勘察不安装": "INVESTIGATION_FINISHED_NOT_INSTALL", "未勘察不安装": "INVESTIGATION_INIT_NOT_INSTALL" };
            const contractStatusNameToCode = { "待联系": "WAIT_CONTRACT", "已联系": "CONTRACTED", "未联系上": "NOT_CONTRACT" };
            if (!this.form.activityOrderInstallStatus && data.activityOrderInstallStatusName) {
              this.form.activityOrderInstallStatus = installStatusNameToCode[data.activityOrderInstallStatusName] || "";
            }
            if (!this.form.activityOrderContractStatus && data.activityOrderContractStatusName) {
              this.form.activityOrderContractStatus = contractStatusNameToCode[data.activityOrderContractStatusName] || "";
            }
            if (data.refundReasonTypeName != null && data.refundReasonTypeName !== undefined) this.form.refundReasonTypeName = data.refundReasonTypeName;
            if (data.buyoutReasonTypeName != null && data.buyoutReasonTypeName !== undefined) this.form.buyoutReasonTypeName = data.buyoutReasonTypeName;
            if (data.buyOutCancelFinishTime != null && data.buyOutCancelFinishTime !== undefined) this.form.buyOutCancelFinishTime = data.buyOutCancelFinishTime;
            if (data.cancelRequestTime != null && data.cancelRequestTime !== undefined) this.form.cancelRequestTime = data.cancelRequestTime;
            if (data.cancelFinishTime != null && data.cancelFinishTime !== undefined) this.form.terminateCompleteTime = data.cancelFinishTime;
            if (data.refundCancelReason != null && data.refundCancelReason !== undefined) this.form.refundCancelReason = data.refundCancelReason;
            if (data.pileCode != null && data.pileCode !== "") {
              this.form.switchDeviceNo = data.pileCode;
              this.form.pileCode = data.pileCode;
            }
            if (data.pileAssetCode != null && data.pileAssetCode !== "") {
              this.form.switchDeviceAssetNo = data.pileAssetCode;
              this.form.pileAssetCode = data.pileAssetCode;
            }
            if (data.actualAmountStatusName != null && data.actualAmountStatusName !== undefined) this.form.actualAmountStatusName = data.actualAmountStatusName;
            if (data.actualAmountCumulativeMonths != null && data.actualAmountCumulativeMonths !== undefined) this.form.actualAmountCumulativeMonths = data.actualAmountCumulativeMonths;
            if (data.actualAmountTotal != null && data.actualAmountTotal !== undefined) this.form.actualAmountTotal = data.actualAmountTotal;
            if (data.flowServiceTotalUsed != null && data.flowServiceTotalUsed !== undefined && (this.form.actualAmountCumulativeMonths === "" || this.form.actualAmountCumulativeMonths === null)) this.form.actualAmountCumulativeMonths = data.flowServiceTotalUsed;
            if (data.flowServicePayment != null && data.flowServicePayment !== undefined && (this.form.actualAmountTotal === "" || this.form.actualAmountTotal === null)) this.form.actualAmountTotal = data.flowServicePayment;
            if (data.isEndDisbursement !== null && data.isEndDisbursement !== undefined) this.form.isEndDisbursement = data.isEndDisbursement;
            if (data.isViolationBuyout !== null && data.isViolationBuyout !== undefined) this.form.isViolationBuyout = data.isViolationBuyout;
            if (data.activityOrderOriginPrice != null && data.activityOrderOriginPrice !== undefined) this.form.buyoutFreeDepositAmount = data.activityOrderOriginPrice;
            if (data.flowSummary) Object.assign(this.flowSummary, data.flowSummary);
            if (Array.isArray(data.flowBills)) this.flowBills = data.flowBills;
            if (data.flowInfo) Object.assign(this.flowSummary, data.flowInfo);
            if (this.activityOrderId) {
              this.loadTrafficStatistics();
              this.loadTrafficBills();
            }
            if (data.terminateSummary) Object.assign(this.terminateSummary, data.terminateSummary);
            if (Array.isArray(data.terminateRecords)) this.terminateRecords = data.terminateRecords;
            if (data.cancelRequestTime) this.terminateSummary.applyTime = data.cancelRequestTime;
            if (data.cancelFinishTime) this.terminateSummary.completeTime = data.cancelFinishTime;
            if (data.refundCancelReason != null && data.refundCancelReason !== "") this.terminateSummary.terminateReason = data.refundCancelReason;
            else if (data.cancelReason != null && data.cancelReason !== "") this.terminateSummary.terminateReason = data.cancelReason;
            if (data.cancelAmount != null && data.cancelAmount !== "") this.terminateSummary.refundAmount = data.cancelAmount;
            if (data.cancelPayableAmount != null && data.cancelPayableAmount !== "") this.terminateSummary.payableAmount = data.cancelPayableAmount;
            this.$nextTick(() => { this.areaSelectKey += 1; });
          } else {
            this.$message.error(res?.data?.message || res?.data?.msg || "获取详情失败");
          }
        })
        .catch(() => { this.$message.error("获取详情失败"); })
        .finally(() => { this.$U.hideLoading(this); });
    },
    loadTrafficStatistics() {
      if (!this.activityOrderId) return;
      this.$H.post(this, this.$A.activityOrder.trafficStatistics, { activityOrderId: this.activityOrderId })
        .then((res) => {
          const data = res?.data?.data || res?.data || {};
          if (res?.data?.status === 200 || res?.data?.data) {
            const statusMap = { TO_EXPRIRED: "即将到期", TO_RENEWED: "待续费", EXPIRED: "已过期", TO_ACTIVE: "待激活", ACTIVE: "正常", IN_ACTIVE: "正常", EXPIRING_SOON: "即将到期", CANCELLED: "已解约（买断）", IN_EXPIRED: "已解约(到期)" };
            this.flowSummary.monthsOnUse = data.monthsOnUse != null && data.monthsOnUse !== "" ? `${data.monthsOnUse}月` : "";
            this.flowSummary.totalPaid = data.accumulatedPayments != null && data.accumulatedPayments !== "" ? `${data.accumulatedPayments}元` : "";
            this.flowSummary.chargingStandards = (data.chargingStandards != null && data.chargingStandards !== "") ? `${data.chargingStandards}元` : "";
            this.flowSummary.currentStatus = statusMap[data.recordStatus] || data.recordStatus || "";
            this.flowSummary.periodStart = data.startTime || "";
            this.flowSummary.periodEnd = data.endTime || "";
            this.flowSummary.remainDays = data.daysRemaining != null && data.daysRemaining !== "" ? `${data.daysRemaining}天` : "";
          }
        })
        .catch(() => { });
    },
    loadTrafficBills() {
      if (!this.form.activityOrderNo && !this.activityOrderId) return;
      const params = {
        activityOrderNo: this.form.activityOrderNo || this.activityOrderId,
        pageNum: 1,
        pageSize: 10,
      };
      if (this.$store?.state?.corpNo) {
        params.corpNo = this.$store.state.corpNo;
      }
      this.$H.post(this, this.$A.activityOrder.circuitBreakerActivityTrafficBillsPage, params)
        .then((res) => {
          const data = res?.data?.data || res?.data || {};
          if (res?.data?.status === 200 || res?.data?.data) {
            const list = data.content || data.list || data.records || [];
            this.flowBills = Array.isArray(list) ? list : [];
          }
        })
        .catch(() => { });
    },
    goBack() { this.$router.back(); },
    onSave() {
      if (!this.form.activityOrderNo) {
        this.$message.error("缺少订单编号");
        return;
      }

      // 调用子组件的验证方法
      if (this.$refs.orderInfo && !this.$refs.orderInfo.validateBeforeSubmit()) {
        return;
      }
      const installStatusCodeToName = { INVESTIGATION_INSTALL_INIT: "未勘察未安装", INVESTIGATION_INSTALL_COMPLETED: "已勘察已安装", INVESTIGATION_FINISHED_NOT_INSTALL: "已勘察不安装", INVESTIGATION_INIT_NOT_INSTALL: "未勘察不安装" };
      const contractStatusCodeToName = { WAIT_CONTRACT: "待联系", CONTRACTED: "已联系", NOT_CONTRACT: "未联系上" };
      const updateParams = {
        activityOrderNo: this.form.activityOrderNo,
        agentName: this.form.agentName || "",
        agentPhone: this.form.agentPhone || "",
        agentLevel: this.form.agentLevel || "",
        parentAgentName: this.form.parentAgentName || "",
        activityOrderInstallStatus: this.form.activityOrderInstallStatus || "",
        activityOrderInstallStatusName: installStatusCodeToName[this.form.activityOrderInstallStatus] || "",
        activityOrderContractStatus: this.form.activityOrderContractStatus || "",
        activityOrderContractStatusName: contractStatusCodeToName[this.form.activityOrderContractStatus] || "",
        installFailReason: this.form.installFailReason || "",
        pileInstallOrderNo: this.form.pileInstallOrderNo || "N",
        pileInstallCompletedTime: this.form.pileInstallCompletedTime || "",
        bindTime: this.form.deviceBindTime || "",
        orderStatus: this.form.orderStatus || "",
        activityOrder: {
          province: this.form.province,
          city: this.form.city,
          area: this.form.area,
          address: this.form.detailAddress,
          remark: this.form.remark || "",
        },
      };
      this.$U.showLoading(this);
      this.$H.post(this, this.$A.activityOrder.update, updateParams)
        .then((res) => {
          if (res?.data?.status === 200) {
            this.$message.success("保存成功");
            this.updateLocalFormData(updateParams);
          } else {
            this.$message.error(res?.data?.message || res?.data?.msg || "保存失败");
          }
        })
        .catch(() => { this.$message.error("保存失败"); })
        .finally(() => { this.$U.hideLoading(this); });
    },
    updateLocalFormData(updatedData) {
      const rootKeys = ["activityOrderInstallStatus", "activityOrderInstallStatusName", "activityOrderContractStatus", "activityOrderContractStatusName", "installFailReason", "pileInstallOrderNo", "pileInstallCompletedTime", "orderStatus", "agentName", "agentPhone", "agentLevel", "parentAgentName"];
      rootKeys.forEach(k => {
        if (updatedData[k] != null && updatedData[k] !== undefined) this.form[k] = updatedData[k];
      });
      if (updatedData.bindTime != null && updatedData.bindTime !== undefined) this.form.deviceBindTime = updatedData.bindTime;
      if (updatedData.activityOrder) {
        const ao = updatedData.activityOrder;
        if (ao.province != null) this.form.province = ao.province;
        if (ao.city != null) this.form.city = ao.city;
        if (ao.area != null) this.form.area = ao.area;
        if (ao.address != null) this.form.detailAddress = ao.address;
        if (ao.remark != null) this.form.remark = ao.remark;
      }
    },
    updateAreaSelection(areaData) {
      this.form.province = areaData.province || "";
      this.form.city = areaData.city || "";
      this.form.area = areaData.area || "";
    },
  },
};
</script>

<style lang="less" scoped>
.bottom-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.detail-container {
  width: 100%;
}

.detail-bread-crumb-div {
  margin-bottom: 10px;
}
</style>
